export function sma(values, n) {
  const out = []; let sum = 0;
  values.forEach((v, i) => { sum += v; if (i >= n) sum -= values[i - n]; out.push(i >= n - 1 ? sum / n : null); });
  return out;
}

export function ema(values, n) {
  const k = 2 / (n + 1); const out = []; let prev = null;
  values.forEach((v, i) => {
    if (i < n - 1) { out.push(null); return; }
    prev = prev == null ? values.slice(0, n).reduce((a, b) => a + b, 0) / n : v * k + prev * (1 - k);
    out.push(prev);
  });
  return out;
}

export function bollinger(values, n = 20, mult = 2) {
  const mid = sma(values, n);
  return values.map((_, i) => {
    if (mid[i] == null) return null;
    const slice = values.slice(i - n + 1, i + 1);
    const sd = Math.sqrt(slice.reduce((a, v) => a + (v - mid[i]) ** 2, 0) / n);
    return { mid: mid[i], upper: mid[i] + mult * sd, lower: mid[i] - mult * sd };
  });
}

export function rsi(values, n = 14) {
  const out = [null]; let gain = 0, loss = 0;
  for (let i = 1; i < values.length; i++) {
    const d = values[i] - values[i - 1];
    const g = Math.max(d, 0), l = Math.max(-d, 0);
    if (i <= n) { gain += g; loss += l; out.push(i === n ? 100 - 100 / (1 + gain / (loss || 1e-9)) : null); if (i === n) { gain /= n; loss /= n; } continue; }
    gain = (gain * (n - 1) + g) / n; loss = (loss * (n - 1) + l) / n;
    out.push(100 - 100 / (1 + gain / (loss || 1e-9)));
  }
  return out;
}

export function macd(values, f = 12, s = 26, sig = 9) {
  const ef = ema(values, f), es = ema(values, s);
  const line = values.map((_, i) => (ef[i] != null && es[i] != null ? ef[i] - es[i] : null));
  const start = line.findIndex((v) => v != null);
  const sigLine = Array(values.length).fill(null);
  if (start >= 0) ema(line.slice(start), sig).forEach((v, i) => { sigLine[start + i] = v; });
  return line.map((m, i) => ({ macd: m, signal: sigLine[i], hist: m != null && sigLine[i] != null ? m - sigLine[i] : null }));
}

export function supportResistance(candles, lookback = 120) {
  const s = candles.slice(-lookback);
  if (!s.length) return null;
  return { support: Math.min(...s.map((c) => c.low)), resistance: Math.max(...s.map((c) => c.high)) };
}
